<template>
  <div class="search-form">
    <el-row>
      <el-col :span="24">
        <el-radio-group v-model="form.queryType" size="mini">
          <el-radio label="A">{{$l('INDEX.template_radio_all') || '全部'}}</el-radio>
          <el-radio label="B">{{$l('INDEX.template_radio_currency') || '仅显示通用'}}</el-radio>
          <el-radio label="C">{{$l('INDEX.template_radio_cust') || '仅显示客户'}}</el-radio>
          <el-radio label="D">{{$l('INDEX.template_radio_allcust') || '客户+终端客户'}}</el-radio>
        </el-radio-group>
      </el-col>
    </el-row>
  </div>
</template>
<script>
const initForm = {
  queryType: 'A',
}

export default {
  data() {
    return {
      form: {...initForm},
    }
  },
  watch: {
    'form.queryType'() {
      this.query()
    },
  },
  methods: {
    //初始查询
    query({isReset = true} = {}) {
      if (isReset) {
        this.$emit('reload')
      }
      this.$emit('query', this.form)
    },
  },
}
</script>
